import { GetTipologiaRappresentanteQuery } from '../../_graphql/generated';

export type TipologiaRappresentanteState = {
  loading: boolean;
  lista: GetTipologiaRappresentanteQuery['anagrafica_tipologia_rappresentante'];
  failure: any;
};

export const initialTipologiaRappresentanteState: TipologiaRappresentanteState =
  {
    loading: false,
    lista: [],
    failure: '',
  };
